import axios from 'axios';
import { ApiErrorMessage } from './ApiClient';

/*`${process.env.REACT_APP_PROTOCOL}://${'naga-den.megakiku.net'}:${
  process.env.REACT_APP_PORT_AUTH
}/auth`*/

const SERVER_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_AUTH_BASE_URL
    : `${process.env.REACT_APP_PROTOCOL}://${window.location.hostname}:${process.env.REACT_APP_PORT_AUTH}/auth`;

export const PostLoginApi = async (body: object) => {
  try {
    const response = await axios
      .create({
        baseURL: SERVER_URL,
        headers: { 'Content-Type': 'application/json' }
      })
      .post('/login', body);
    return { success: true, data: response, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};
